module.exports = __webpack_public_path__ + "img/john-de-wolf2.e7a45e16.jpg";